<template>
  <div class="card-n">
    <div class="title">
      {{ $t("user.mine.tranerIn") }}
    </div>
    <h5 class="scan">扫描二维码，转入MASS</h5>
    <div class="qrCodePanel">
      <div class="qrCode" ref="qrCodeUrl"></div>
    </div>
    <h5 class="my">{{ $t("home.components.transIn.myadd") }}</h5>
    <div class="add">{{ wallets.address }}</div>
    <h5
      class="copy"
      v-clipboard="wallets.address"
      v-clipboard:success="clipboardSuccessHandler"
      v-clipboard:error="clipboardErrorHandler"
    >
      {{ $t("home.components.transIn.copy") }}
    </h5>
    <h5 class="tip">{{ $t("home.components.transIn.tip") }}</h5>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("wallet", ["wallets"]),
  },
  watch: {
    "wallets.address": {
      handler(val) {
        if (val) {
          this.creatQrCode();
        }
      },
    },
  },
  mounted() {
    this.creatQrCode();
  },
  methods: {
    clipboardSuccessHandler() {
      this.$tooltip.success(this.$t("home.components.transIn.success"));
    },
    clipboardErrorHandler() {
      this.$tooltip.success(this.$t("home.components.transIn.fail"));
    },
    creatQrCode() {
      new QRCode(this.$refs.qrCodeUrl, {
        text: this.wallets.address, 
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
  },
};
</script>
<style>
.qrCodePanel canvas {
  display: none;
}
@media screen and (max-width: 768px) {
  .card-n{
    width: auto !important;
  }
}
</style>
<style lang="sass" scoped>

.qrCodePanel
  text-align: center;
  padding: 17px 0 13px 0;

.qrCode
  display: inline-block;
  background: #D8D8D8;

.card-n
  padding: 2rem 2rem
  background: url('~@/assets/image/modal_sm.png') no-repeat
  background-size: 100% 100%
  width: 420px
  height: 456px
  .title
    width: 100%
    border-bottom: 0.1rem solid rgba(222,222,222,0.4)
    padding-bottom: 2rem
    float: left
    color: #333333
    font-size: 1.6rem
    font-weight: bold
    margin-bottom: 2rem
    position: relative
    .logo
      width: 3.5rem
    .text
      position: absolute
      top: 1rem
      left: 4.5rem
  .scan
    color: #333333
    font-size: 1.2rem
    font-weight: 400
    text-align: center
  .code
    width: 11rem
    padding-top: 1.7rem
    padding-bottom: 1.3rem
    text-align: center
  .my
    color: #333333
    font-size: 1.4rem
    font-weight: 400
    padding-bottom: 0.8rem
    text-align: center
  .add
    color: rgba(51,51,51,0.7)
    font-size: 1.2rem
    font-weight: 400
    width: 30rem
    word-break: break-all
    position: absolute
    transform: translateX(-50%)
    left: 50%
    text-align: center
  .copy
    color: #DC472A
    font-size: 1.4rem
    font-weight: bold
    text-decoration: underline
    padding: 1.9rem 0 3.9rem 0
    margin-top: 3.8rem
    text-align: center
  .tip
    color: #D0021B
    font-size: 1.2rem
    font-weight: 400
    text-align: center
</style>

